import {
	Component,
	ElementRef,
	EventEmitter,
	Inject,
	Input,
	OnInit,
	Output,
	ViewChild,
	ViewEncapsulation,
} from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { UrlService } from '@service/url/url.service';
import { RestService } from 'cargo-chief-commons';
import { UtilService } from '@service/util/util.service';
import { CustomRestService } from '@service/customRest/custom-rest.service';
import { SNACKBAR } from '@domain/constants/snackbar-setting';
import { environment } from '@environment/environment';
import { S3_CSV_TEMPLATE } from '@domain/constants/app-variables';
import { SegmentEventsConstants } from '@domain/constants/segment-events-constants';
import { SegmentWrapperService } from '@service/segmentWrapper/segment-wrapper.service';
import { Cargochief } from '@service/cargochief/cargochief.service';
import moment from 'moment';

@Component({
	selector: 'app-upload-pricing-data',
	templateUrl: './upload-pricing-data.component.html',
	styleUrls: ['./upload-pricing-data.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class UploadPricingDataComponent implements OnInit {
	@Input() useButton = false;
	@Input() isMenuButton = false;
	@Input() useText = false;
	@Input() accountId;
	@Input() labelClass: string = '';
	@Input() text: string = '';
	@Input() fromHotLanesCard = false;
	@Input() title: string = 'Upload CSV file';
	@Output() dataUploaded: EventEmitter<any> = new EventEmitter();

	constructor(public dialog: MatDialog) {}

	ngOnInit() {}

	openDialog() {
		const dialogRef = this.dialog.open(UploadPricingDataDialog, {
			width: '1000px',
			data: {
				accountId: this.accountId,
				fromHotLanesCard: this.fromHotLanesCard,
				title: this.title,
			},
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (!!result) {
				// this.dataUploaded.emit(result)
			}
		});
	}
}

@Component({
	selector: 'app-upload-pricing-dialog',
	templateUrl: 'modal.template.html',
})
export class UploadPricingDataDialog {
	isUpdating = false;
	fileToUpload: File = null;
	fileData = null;
	accountId = null;
	isXLSXFile = false;
	fromHotLanesCard = false;
	title = '';
	S3_CSV_TEMPLATE = S3_CSV_TEMPLATE;

	// @ViewChild('stepper') stepper: MatStepper;
	@ViewChild('fileInput') fileInput: ElementRef;

	constructor(
		public dialogRef: MatDialogRef<UploadPricingDataDialog>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private urlService: UrlService,
		private restService: RestService,
		public utilService: UtilService,
		private customRestService: CustomRestService,
		private segmentWrapper: SegmentWrapperService,
		private cargoChief: Cargochief
	) {
		this.accountId = this.data.accountId;
		this.fromHotLanesCard = this.data.fromHotLanesCard;
		this.title = this.data.title;
	}

	closeDialog(): void {
		this.dialogRef.close(null);
	}

	handleFileInput(files: FileList) {
		const self = this;
		self.isXLSXFile = this.isXLSXFile;
		this.fileToUpload = files.item(0);
		let fileReader = new FileReader();
		fileReader.onload = (fileLoadedEvent) => {
			let textFromFileLoaded = fileLoadedEvent.target['result'];
			let allTextLines = (textFromFileLoaded as string).split(/\r\n|\n/);
			let headers = allTextLines[0].split(',');
			let lines = [];
			for (let i = 0; i < allTextLines.length; i++) {
				let data = allTextLines[i].split(',');
				if (data.length == headers.length) {
					let tarr = [];
					for (let j = 0; j < headers.length; j++) {
						tarr.push(data[j]);
					}
					lines.push(tarr);
				}
			}
			self.fileData = lines;
			self.afterFileUpload({
				fileToUpload: self.fileToUpload,
				fileData: self.fileData,
				isExcelFile: self.isXLSXFile,
			});
		};
		fileReader.readAsText(this.fileToUpload, 'UTF-8');
	}

	afterFileUpload({ fileToUpload, fileData, isExcelFile }) {
		this.isXLSXFile = isExcelFile;
		this.fileToUpload = fileToUpload;
		this.fileData = fileData;
	}

	getSignedUrl() {
		this.isUpdating = true;
		const filename = `${
				!this.utilService.isAccountTypeAdmin()
					? this.cargoChief.BUSINESS_NAME.replace(/\s/g, '')
					: ''
			}_${moment(new Date()).format('MM_DD_YY_HH_mm_ss')}_Historical_Loads_account_${
				this.accountId
			}`,
			fileType = this.fileToUpload.name.split('.').pop();
		const url = this.urlService.awsPreSignedUrl(
			environment.PRICING_DATA_CONFIG.bucketName,
			filename,
			fileType,
			true
		);
		this.restService.GET(url).subscribe(
			(result) => {
				this.uploadCSVFileToS3PreSignedUrl(result['data'], result['objectKey'], filename);
			},
			(_) => {
				this.isUpdating = false;
				this.utilService.showSnackbar('Unable to get signed URL.', SNACKBAR.ERROR, SNACKBAR.ACTION);
			}
		);
	}

	uploadCSVFileToS3PreSignedUrl(signedUrl: string, objectId: string, filename: string) {
		const fileToUpload: File = new File([this.fileToUpload], filename, {
			type: this.fileToUpload.type,
		});
		this.customRestService.uploadCsvFileToS3(signedUrl, fileToUpload).subscribe(
			(_) => {
				this.isUpdating = false;
				// this is when uploading file to lanemaster loads bucket
				// this.addPricingDataForAccount(objectId);
				this.closeDialog();
				this.utilService.showSnackbar(
					'Your transaction data has been uploaded.',
					SNACKBAR.SUCCESS,
					SNACKBAR.ACTION
				);
			},
			(error) => {
				this.isUpdating = false;
				this.segmentWrapper.fireSegmentEvent(
					SegmentEventsConstants.user_failed_to_upload_pricing_data,
					{}
				);
				this.utilService.showSnackbar(
					'Unable to upload your file.',
					SNACKBAR.ERROR,
					SNACKBAR.ACTION
				);
			}
		);
	}

	addPricingDataForAccount(s3ObjectId: any) {
		const url = this.urlService.addPricingDataForAccount(this.accountId);
		this.restService.POST(url, { filename: s3ObjectId, accountId: this.accountId }).subscribe(
			(result) => {
				this.utilService.showSnackbar(
					'Your transaction data has been uploaded.',
					SNACKBAR.SUCCESS,
					SNACKBAR.ACTION
				);
			},
			(error) => {
				let errorMessage = 'Unable to upload your file.';
				this.segmentWrapper.fireSegmentEvent(
					SegmentEventsConstants.user_failed_to_upload_pricing_data,
					{}
				);
				this.utilService.showSnackbar(errorMessage, SNACKBAR.ERROR, SNACKBAR.ACTION);
			}
		);
	}

	clearFile() {
		this.fileToUpload = null;
		this.fileData = null;
	}
}
